import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButtonModule } from '@angular/material/button';
import { StatusTypeService } from '../../../services/status-type.service';
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-modal-status-type-form',
  imports: [
    ReactiveFormsModule,
    MatIcon,
    MatFormFieldModule,
    MatInput,
    MatButtonModule,
    MatProgressSpinner,
    CommonModule,
    MatButtonToggleModule,
    MatDialogModule,
],
  templateUrl: './modal-status-type-form.component.html',
  styleUrl: './modal-status-type-form.component.css'
})
export class ModalStatusTypeFormComponent {
  isLoading = true;
  errorMessage = '';
  edditing = false;

  statusTypeForm = new FormGroup({
    id: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required]
    }),
    name: new FormControl(''),
    description: new FormControl(''),
    type: new FormControl(0)
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public id: string,
    private statusTypeService: StatusTypeService,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ModalStatusTypeFormComponent>
  ) {
    if(id){
      this.edditing = true;
      console.log("Edytownaie-modal: ",id);
      this.statusTypeService.getStatusType(id)
      .subscribe({
        next: res => {
          console.log("Wczytane dane: ",res);
          this.isLoading = false;
          this.statusTypeForm.setValue({
            id: res.id,
            name: res.name?? "",
            description: res.description?? "",
            type: res.alert ? 0 : 1
          });
        },
        error: err => {
          this.isLoading = false;
          this.errorMessage = err.message + ' ' + err.status;
          console.error(err);
        }
      })
    } else {
      console.log("Dodawanie-modal");
      this.isLoading = false;
    }
  }

  onSubmit() {
    console.log("Submited");
    if(this.statusTypeForm.valid) {
      const data = {
        id: this.statusTypeForm.get('id')!.value,
        name: this.statusTypeForm.get('name')?.value,
        description: this.statusTypeForm.get('description')?.value,
        type: "APPLICATION",
        alert: this.statusTypeForm.get('type')!.value === 0 ? true : false,
        error: this.statusTypeForm.get('type')!.value === 1 ? true : false,
      };
      console.log("Wgrane Body: ", data);
      
      if(this.edditing){
        this.statusTypeService.updateStatusType(this.statusTypeForm.get('id')!.value, data)
        .subscribe({
          next: res => {
            this.snackBar.open("Zapisane", "",{duration:2000})
            this.dialogRef.close(true)
          },
          error: err => {
            this.snackBar.open("Coś poszło nie tak", "",{duration:2000})
            console.error(err);
          }
        });
      } else {
        console.log("Dodawanie: ",data);
        
        this.statusTypeService.createStatusType(data)
        .subscribe({
          next: res => {
            this.snackBar.open("Dodane", "",{duration:2000})
            this.dialogRef.close(true)
          },
          error: err => {
            this.snackBar.open("Coś poszło nie tak", "",{duration:2000})
            console.error(err);
          }
        });
      }
      
    } else {
      this.snackBar.open("Uzupełnij pole id","OK", {duration:5000})
    }
  }
}
